import type { ISearchGrouped } from "@model/Search.model";
import { SEARCH_SET_INDEX, SEARCH_SET_QUERY, SEARCH_LOAD_FAILURE } from "Data/Search/SearchActionTypes";
import type { ActionWithPayload } from "@model/Store.model";

export type SearchState = {
  searchCatalogByType: ISearchGrouped;
  query: string;
  error: string | null; 
};

const INITIAL: SearchState = {
  searchCatalogByType: { categories: [], products: [], services: [] },
  query: "",
  error: null,
};

export const SearchReducer = (
  state: SearchState = INITIAL,
  action: ActionWithPayload
): SearchState => {
  switch (action.type) {
    case SEARCH_SET_INDEX: {
      const payload = action.payload as ISearchGrouped;
      return { ...state, searchCatalogByType: payload, error: null }; 
    }
    case SEARCH_SET_QUERY: {
      const payload = (action.payload as string) ?? "";
      return { ...state, query: payload };
    }
    case SEARCH_LOAD_FAILURE: {
      return { ...state, error: action.payload as string }; 
    }
    default:
      return state;
  }
};
